<template>
  <div class="sub-layout">
    <div class="sub_toptit">
      <h1>Venue Information</h1>
    </div>

    <div class="contentBox">
      <div class="sub_container">
        <div class="abgtitle">
            <h1>COEX Magok</h1>
            <p class="maindesc">In 2025, KOREADERMA 2025 will be held at a new venue, COEX Magok.</p>
        </div>

        <div class="hotelwrap">
            <div class="hoteltop">
                <img src="@/assets/img/venuehotel.jpg">
            </div>
            <!-- <div class="hotelmap">
                <img src="@/assets/img/hotelmap2024-1.jpg">
            </div> -->
            <div class="hoteladd">
                <h2>Address &amp; inquiries</h2>
                <div class="hoteladdwrap">
                    <div class="hotelad1">
                        <div class="hoteliconbox">
                            <div class="hicon">
                                <img class=" lazyloaded" src="@/assets/img/hotelicon1.png">
                            </div>
                            <div class="hotinfo"><b>Address</b><br>
                                143, Magokjungang-ro, Gangseo-gu, Seoul, Republic of Korea</div>
                        </div>
                        <div class="hoteliconbox">
                            <div class="hicon">
                                <img src="@/assets/img/hotelicon3.png">
                            </div>
                            <div class="hotinfo"><b>Tel</b><br>
                                +82-2-767-6030</div>
                        </div>
                    </div>
                    <div class="hotelad1 hotelad2">
                        <div class="hoteliconbox">
                            <div class="hicon">
                                <img src="@/assets/img/hotelicon2.png">
                                </div>
                            <div class="hotinfo">
                                <b>Homepage</b><br>
                                <a href="https://coexmagok.co.kr/" target="_blank">https://coexmagok.co.kr/
                                    <img src="@/assets/img/link.png">
                                </a>
                            </div>
                        </div>
                        <div class="hoteliconbox">
                            <div class="hicon">
                                <img src="@/assets/img/hotelicon4.png">
                            </div>
                            <div class="hotinfo"><b>Fax</b><br>
                                +82-2-767-6000
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

         <!-- <div class="suttlebox">
             <h1>KOREADERMA Shuttle Bus</h1>
             <p>Shuttle bus will be operated between Yangjae Station, nearby hotel, and the conference venue.<br>
                 Shuttle Bus Operating Hours
                 <a href="/files/KD2024_Shuttle-Bus_Operating-Hours.pdf" target="_blank">[View]</a></p>
         </div> -->

         <div class="agtitle">
             <h4>Public transportation</h4>
         </div>

         <div class="vtranswrap">
             <div class="transtwo">
                 <div class="trans1">
                     <div class="transicon">
                        <img src="@/assets/img/vt1.png"></div>
                     <h3>Subway</h3>
                     <div class="agul">
                         <ul>
                             <li>
                                <span class="vtred">Exit 6 from Magongnaru station, Airport Line</span> (5-min walk)
                            </li>
                             <li>
                                <span class="vtorange">Exit 2 from Magongnaru station, Line 9</span> (5-min walk)
                            </li>
                         </ul>
                     </div>
                 </div>
                 <div class="trans1 trans2">
                     <div class="transicon">
                        <img src="@/assets/img/vt2.png"></div>
                     <h3>Bus</h3>
                     <div class="agul">
                         <ul>
                             <li>
                                <b>Green bus</b><br>
                                 6642, 6645, 6648, Gangseo 07<br>
                                 Disembark at Magongnaru station (5-min walk)
                            </li>
                             <li>
                                <b>Blue bus</b><br>
                                9731<br>
                                Disembark at Magongnaru station (5-min walk)
                            </li>
                         </ul>
                     </div>
                 </div>
             </div>
         </div>

         <div class="vtranswrap">
             <div class="transtwo">
                 <div class="trans1">
                    <div class="transicon">
                        <img src="@/assets/img/vt3.png">
                    </div>
                     <h3>Airport bus</h3>
                     <div class="agul">
                         <ul>
                             <li>
                                <b>Airport limousine bus #6003</b><br>
                                 From Incheon International Airport<br>
                                 Bus from <span class="grone">Terminal 1</span> (Floors 1, 6A-1)<br>
                                 Bus from <span class="grone">Terminal 2</span> (Underground floors 1, 24)<br>
                                 Disembark at Magongnaru station, and take a bus(6645, 6648, gangseo 05-1)
                            </li>
                            <li>
                                <b>Service hours</b><br>
                                 <span class="vtblue">To airport</span> : Terminal 1 and 2 ( 4:20 - 20:00)<br>
                                 <span class="vtblue">To city</span> : Terminal 1 and 2 (5:30 - 22:50)
                            </li>
                         </ul>
                     </div>
                 </div>
                 <!-- <div class="trans1 trans2">
                     <div class="transicon">
                        <img src="@/assets/img/vtmap.png">
                    </div>
                 </div> -->
             </div>
         </div>


      </div>
    </div>
  </div>
</template>

<script>




export default {
  name: 'Venue Information',
  data() {
    return {

    };
  },
  components: {

  },
  methods: {
 
  },
  mounted() {



  },
  methods: {
    
  },
};
</script>